import { L10nContext } from 'context/L10nContext';
import { useContext } from 'react';
import { getDeviceTypeDefinition } from 'services/device/domain/business/inventory/DeviceTypeDefinition';
import { DeviceViewModel } from 'services/device/domain/model/DeviceModel';
import { DeviceModelState } from 'services/device/domain/model/DeviceModelState';
import { DeviceViewModalType } from 'services/device/presentation/view/DeviceViewModalType';
import { User } from 'services/device/presentation/view/UserModel';

import { CardDeviceDetail } from 'presentation/ui/components/cards/card-device/card-device-detail/CardDeviceDetail';
import {
	CardItemDeviceDetailAttributes,
} from 'presentation/ui/partials/card/card-item-attributes/card-item-device-detail-attributes/CardItemDeviceDetailAttributes';
import { CardItemSingleControl } from 'presentation/ui/partials/card/card-item-controls/card-item-single-control/CardItemSingleControl';
import { CardItemControlState } from 'presentation/ui/partials/card/card-item-controls/CardItemControlState';
import { CardItemHeader } from 'presentation/ui/partials/card/card-item-header/card-item-header/CardItemHeader';
import { mapTypeToIlluIdentifier } from 'presentation/ui/partials/illustration/IllustrationIdentifierMapper';

interface DeviceCardProps {
	device: DeviceViewModel;
	// eslint-disable-next-line react/require-default-props
	user?: User;
	location: string;
	// eslint-disable-next-line react/require-default-props
	onClick?: (modalType: DeviceViewModalType) => void;
}

export const DeviceCard = (props: DeviceCardProps): JSX.Element => {
	const { device, user, location, onClick } = props;

	const l10nContext = useContext(L10nContext);

	const deviceTypeDefinition = getDeviceTypeDefinition(device.Type);

	return (
		<CardDeviceDetail>
			<CardItemHeader
				title={device.Name}
				subtitle={l10nContext.translate(deviceTypeDefinition.getLabelKey())}
				illustration={mapTypeToIlluIdentifier(device?.Type)}
				archived={device.State === DeviceModelState.ARCHIVED}
			/>
			<CardItemSingleControl
				cardId={device.Uuid}
				actionEdit={user.permission.edit ?
					CardItemControlState.ENABLED :
					CardItemControlState.DISABLED}
				onClick={() => onClick(DeviceViewModalType.EDIT)}
			/>
			<CardItemDeviceDetailAttributes
				ident={device.Identifier}
				location={location}
				serialNumber={device.SerialNumber}
				locationDescription={device.Location}
			/>
		</CardDeviceDetail>
	);
};
